import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Layout from "../../layout/Layout";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../common/loader";
import {
  fetchBookingList,
  fetchBusiness,
  fetchBusinessBooking,
  fetchBusinessServices,
  fetchBusinessServicesBooking,
  fetchBusinessStaff,
  fetchBusinessStaffBooking,
  fetchCouponCode,
  fetchUser,
  fetchUserBooking,
} from "../../redux/adminReducer";
import { IoEyeOutline } from "react-icons/io5";
import Modal from "../../common/modal";
import { toast } from "react-toastify";
import { getApi, postApi } from "../../api/axiosInstance";
import { API_PATH } from "../../api/apiPath";
function Booking({ userId, salonId, role }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { translations, dir } = useSelector((state) => state.language);
  const [currentPage, setCurrentPage] = useState(1);
  const [filter, setFilter] = useState("all");
  const itemsPerPage = 10;
  const dispatch = useDispatch();
  const [bookingData, setBookingData] = useState([]);
  const [totalBookingCount, setTotalBookingCount] = useState(0);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const initialDummyBooking = {
    user_id: "",
    salon_id: "",
    staff_id: "",
    service_ids: [],
    booking_date: "",
    start_time: "",
    total_duration: "",
    payment_method: "",
    instructions: "",
    promoCode: "",
  };

  const [dummyBooking, setDummyBooking] = useState(initialDummyBooking);
  const [errors, setErrors] = useState({});
  const [salonIdState, setSalonIdState] = useState(null);
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [staffList , setStaffList] = useState([])
  const salons = useSelector(
    (state) => state.admin.salonList?.data?.salons || []
  );

  const users = useSelector((state) => state.admin.userList?.data?.users || []);

  // const staffList = useSelector(
  //   (state) => state.admin.staffBooking?.data || []
  // );

  const services = useSelector(
    (state) => state.admin.businessServicesBookings?.data || []
  );
  console.log(staffList);
  const promoCodes = useSelector((state) => state.admin.codes?.data || []);

  // const [users, setUsers] = useState([]);
  // const [salons, setSalons] = useState([]);
  // const [staffList, setStaffList] = useState([]);
  // const [services, setServices] = useState([]);
  // const [promoCodes, setPromoCodes] = useState([]);

  const fetchBookings = async (b) => {
    try {
      setLoading(true);
      if (role === "user") {
        const b = {
          userId,
          currentPage,
          filter,
        };
        const res = await dispatch(fetchUserBooking(b)).unwrap();
        setBookingData(res.data);
        setTotalBookingCount(res.pagination.total);
      } else if (role === "salon") {
        const b = {
          salonId,
          currentPage,
          filter,
        };
        const res = await dispatch(fetchBusinessBooking(b)).unwrap();
        setBookingData(res.data);
        setTotalBookingCount(res.pagination.total);
      } else {
        const b = {
          currentPage,
          filter,
        };
        const res = await dispatch(fetchBookingList(b)).unwrap();
        setBookingData(res.bookings);
        setTotalBookingCount(res.totalBookings);
      }
    } catch (error) {
      console.error("Error fetching rides:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchStaff =async (salonId) => {
      console.log(salonId)
      try {
        const response = await getApi(
          `${API_PATH.ADMIN.GET_BUSINESS_STAFF}/${salonId}`
        );
        const staff = response.data.data;
        setStaffList(staff);
      } catch (error) {
        console.error("Error fetching staff:", error);
      }
    }

  useEffect(() => {
    const b = {
      currentPage,
      filter,
    };
    fetchBookings(b);
    dispatch(fetchBusiness());
    dispatch(fetchUser());
    if(salonIdState){
fetchStaff(salonIdState)
    }
    // dispatch(fetchBusinessStaffBooking(salonIdState));
    // dispatch(fetchBusinessServicesBooking(salonIdState));
    dispatch(fetchCouponCode());
  }, [dispatch, currentPage, filter, role, userId, salonId, salonIdState]);

  const [error, setError] = useState("");
  const handlePageChange = (event) => {
    const selectedPage = Number(event.target.value);

    if (selectedPage > totalPages) {
      setError(`Maximum value must be ${totalPages}`);
      // setCurrentPage(totalPages);
      return;
    }
    setCurrentPage(selectedPage);
    setError("");
  };
  const totalPages = Math.ceil(totalBookingCount / itemsPerPage);

  const handleRowClick = (bookingId) => {
    navigate(`/booking/booking-details/${bookingId}`);
  };

  const validateAndSubmit = async () => {
    const newErrors = {};

    // Clear previous errors
    setErrors({});

    // Required field validations
    if (!dummyBooking.user_id)
      newErrors.user_id = translations.dummyBooking.userRequired;
    if (!dummyBooking.salon_id)
      newErrors.salon_id = translations.dummyBooking.salonRequired;
    if (!dummyBooking.staff_id)
      newErrors.staff_id = translations.dummyBooking.staffRequired;
    if (!dummyBooking.service_ids || dummyBooking.service_ids.length === 0)
      newErrors.service_ids = translations.dummyBooking.serviceRequired;
    if (!dummyBooking.booking_date)
      newErrors.booking_date = translations.dummyBooking.dateRequired;
    if (!dummyBooking.start_time)
      newErrors.start_time = translations.dummyBooking.timeRequired;
    if (!dummyBooking.total_duration)
      newErrors.total_duration = translations.dummyBooking.durationRequired;
    if (!dummyBooking.payment_method)
      newErrors.payment_method =
        translations.dummyBooking.paymentMethodRequired;

    // Format validations
    const datePattern = /^\d{4}-\d{2}-\d{2}$/;
    if (
      dummyBooking.booking_date &&
      !datePattern.test(dummyBooking.booking_date)
    ) {
      newErrors.booking_date = translations.dummyBooking.dateFormat;
    }

    const timePattern = /^(0[1-9]|1[0-2]):[0-5][0-9] (AM|PM)$/;
    if (dummyBooking.start_time && !timePattern.test(dummyBooking.start_time)) {
      newErrors.start_time = translations.dummyBooking.timeFormat;
    }

    if (dummyBooking.total_duration && dummyBooking.total_duration <= 0) {
      newErrors.total_duration = translations.dummyBooking.durationFormat;
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    try {
      const res = await postApi(
        `${API_PATH.ADMIN.DUMMY_BOOKING}`,
        dummyBooking
      );

      console.log("Booking created successfully:", res);
      toast.success(translations.toaster.dummyBookingSuccess);
      const b = {
        currentPage,
        filter,
      };
      fetchBookings(b);
      setIsAddModalOpen(false);
      setDummyBooking(initialDummyBooking);
      setSelectedStaff(null);
    } catch (error) {
      console.error("Booking creation failed:", error);
      toast.error(
        error?.response?.data?.message ||
          translations.toaster.dummyBookingFailed
      );
    }
  };

  const generateTimeSlots = (start, end, interval = 60) => {
    const slots = [];
    const [startHour, startMin] = start.split(":").map(Number);
    const [endHour, endMin] = end.split(":").map(Number);

    let current = new Date();
    current.setHours(startHour, startMin, 0, 0);

    const endTime = new Date();
    endTime.setHours(endHour, endMin, 0, 0);

    while (current <= endTime) {
      const hours = current.getHours();
      const minutes = current.getMinutes();
      const ampm = hours >= 12 ? "PM" : "AM";
      const displayHours = (hours % 12 || 12).toString().padStart(2, "0");
      const displayMinutes = minutes < 10 ? `0${minutes}` : minutes;

      slots.push(`${displayHours}:${displayMinutes} ${ampm}`);
      current.setMinutes(current.getMinutes() + interval);
    }

    return slots;
  };

  const BookingContent = (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-2xl font-semibold text-white">
              {translations.booking.bookingList}
            </h2>

            <div className="flex items-center space-x-4">
              {/* Conditionally render button for non-user/salon roles */}
              {role !== "user" && role !== "salon" && (
                <button
                  onClick={() => setIsAddModalOpen(true)}
                  className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded"
                >
                  Add Dummy Booking
                </button>
              )}

              {/* Filter Dropdown */}
              <div className="flex items-center">
                <label htmlFor="salon-status" className="text-white px-2">
                  {translations.booking.filter} :
                </label>
                <div className="relative">
                  <select
                    id="salon-status"
                    className="bg-gray-700 text-white rounded ps-2 pe-5 py-2 focus:outline-none w-full appearance-none"
                    value={filter}
                    onChange={(e) => {
                      const value =
                        e.target.value === "all"
                          ? "all"
                          : Number(e.target.value);
                      setFilter(value);
                      setCurrentPage(1);
                    }}
                  >
                    <option value="all">{translations.booking.all}</option>
                    <option value="200">{translations.booking.pending}</option>
                    <option value="201">
                      {translations.booking.confirmed}
                    </option>
                    <option value="202">
                      {translations.booking.rescheduled}
                    </option>
                    <option value="203">
                      {translations.booking.cancelled}
                    </option>
                    <option value="204">
                      {translations.booking.completed}
                    </option>
                    <option value="205">{translations.booking.noShow}</option>
                  </select>

                  <div className="absolute inset-y-0 right-0 flex items-center px-3 pointer-events-none">
                    <svg
                      className="w-4 h-4 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M19 9l-7 7-7-7"
                      ></path>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {bookingData?.length === 0 ? (
            <div className="flex h-64 items-center justify-center text-gray-500 dark:text-gray-400">
              <p className="text-xl">{translations.booking.noData}</p>
            </div>
          ) : (
            <>
              <div className="grid  md:grid lg:grid  overflow-x-auto ">
                <table className="min-w-full text-white shadow-md   p-2">
                  <thead className="bg-[#5A189A] text-white text-md text-center">
                    <tr>
                      <th className=" px-3 py-3 whitespace-nowrap">
                        {translations.booking.userName}
                      </th>
                      <th className=" px-3 py-3 whitespace-nowrap">
                        {translations.booking.salonName}
                      </th>
                      <th className=" px-3 py-3 whitespace-nowrap">
                        {translations.booking.staffName}
                      </th>
                      <th className=" px-3 py-3 whitespace-nowrap">
                        {translations.booking.bookingDate}
                      </th>

                      <th className=" px-3 py-3 whitespace-nowrap">
                        {translations.booking.duration}
                      </th>
                      <th className=" px-3 py-3 whitespace-nowrap">
                        {translations.booking.status}
                      </th>
                      <th className=" px-3 py-3 whitespace-nowrap">
                        {translations.booking.timing}
                      </th>
                      <th className=" px-3 py-3 whitespace-nowrap">
                        {translations.booking.userPhone}
                      </th>
                      {role !== "user" && role !== "salon" && (
                        <th className=" px-3 py-3 whitespace-nowrap">
                          {translations.booking.actions}
                        </th>
                      )}
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-600 ">
                    {bookingData?.map((booking, index) => (
                      <tr key={index} className="transition  text-center mb-3">
                        <td className="px-3 py-3">{booking.user_id.name}</td>
                        <td className="px-3 py-3">
                          {booking.salon_id.business_name}
                        </td>
                        {booking?.anyProfessional === true ? (
                          <td className="px-3 py-3">
                            {translations.booking.anyProfessional}
                          </td>
                        ) : (
                          <td className="px-3 py-3">{booking.staff_id.name}</td>
                        )}

                        <td className="px-3 py-3">{booking.booking_date}</td>
                        <td className="px-3 py-3">
                          {booking.total_duration} mins
                        </td>
                        <td className="px-3 py-3">
                          <span
                            className={`px-3 py-1 rounded-full text-sm font-semibold
                                        ${
                                          booking.status === 200
                                            ? "bg-yellow-200 text-yellow-700"
                                            : booking.status === 201
                                            ? "bg-blue-200 text-blue-700"
                                            : booking.status === 202
                                            ? "bg-purple-200 text-purple-700"
                                            : booking.status === 203
                                            ? "bg-red-200 text-red-700"
                                            : booking.status === 204
                                            ? "bg-green-200 text-green-700"
                                            : booking.status === 205
                                            ? "bg-gray-200 text-gray-700"
                                            : ""
                                        }`}
                          >
                            {booking.status === 200
                              ? translations.booking.pending
                              : booking.status === 201
                              ? translations.booking.confirmed
                              : booking.status === 202
                              ? translations.booking.rescheduled
                              : booking.status === 203
                              ? translations.booking.cancelled
                              : booking.status === 204
                              ? translations.booking.completed
                              : translations.booking.noShow}
                          </span>
                        </td>
                        <td className="px-3 py-3">
                          {booking.start_time}-{booking.end_time}
                        </td>
                        <td
                          className="px-3 py-3  whitespace-nowrap"
                          style={{ direction: "ltr" }}
                        >
                          {booking.user_id.fullPhoneNumber}
                        </td>

                        {role !== "user" && role !== "salon" && (
                          <td className="px-4 py-5 flex ">
                            <button
                              className="hover:text-green-600  text-2xl"
                              onClick={() => handleRowClick(booking._id)}
                            >
                              <IoEyeOutline />
                            </button>
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {/* Pagination Controls */}
              <div className="mt-4 flex justify-between text-white">
                <svg
                  className={`${
                    currentPage === 1
                      ? "fill-current"
                      : "cursor-pointer fill-current"
                  }
                        ${dir === "rtl" && "rotate-180"}`}
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 320 512"
                  width={24}
                  height={24}
                  onClick={() =>
                    setCurrentPage((prev) => Math.max(prev - 1, 1))
                  }
                  aria-disabled={currentPage === 1}
                >
                  <path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z" />
                </svg>
                <span>
                  {translations.booking.page}
                  {totalPages > 1 ? (
                    <input
                      type="number"
                      name=""
                      id="pagination-jump"
                      className={
                        error
                          ? `mx-2 rounded-md border  ps-1 border-red  bg-gray-800 text-white shadow-card focus:border-primary`
                          : `mx-2 rounded-md border border-gray-300 ps-1  bg-gray-800 text-white shadow-card focus:border-primary`
                      }
                      min={1}
                      max={totalPages}
                      defaultValue={currentPage}
                      onChange={(e) => e.target.value}
                      onBlur={(e) => handlePageChange(e)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          handlePageChange(e);
                        }
                      }}
                    />
                  ) : (
                    <span className="mx-1">{currentPage}</span>
                  )}
                  {translations.booking.of} {totalPages}
                </span>
                <svg
                  className={`${
                    currentPage === totalPages
                      ? "fill-current"
                      : "cursor-pointer fill-current"
                  }
                        ${dir === "rtl" && "rotate-180"}`}
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 320 512"
                  onClick={() =>
                    setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                  }
                  aria-disabled={currentPage === totalPages}
                >
                  <path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z" />
                </svg>
              </div>
            </>
          )}
        </>
      )}
    </>
  );

  return role ? (
    BookingContent
  ) : (
    <>
      <Layout>
        <div className="min-h-screen w-full  px-4 py-4">
          <section className="pt-1 grid grid-cols-2 items-center">
            <h1 className="text-xl font-bold text-white">
              {translations.booking.bookings}
              <small className="text-2xl font-semibold text-gray-600"> |</small>
              <small className="font-normal text-gray-600">
                {" "}
                {translations.booking.bookingManagement}
              </small>
            </h1>

            <div className="text-md text-white flex items-center justify-end space-x-1 ">
              <div className="rounded-full bg-[#5A189A] py-2 px-3">
                <Link
                  to="/"
                  className=" text-white  no-underline cursor-pointer"
                >
                  {translations.booking.dashboard}
                </Link>
                <span className="mx-1">/</span>
                <span className="text-green-300 ">
                  {translations.booking.bookings}{" "}
                </span>
              </div>
            </div>
          </section>
          <div className="p-4 w-full bg-gray-800 shadow-xl rounded mt-5">
            {BookingContent}
          </div>
        </div>
      </Layout>
      <Modal
        isOpen={isAddModalOpen}
        onClose={() => setIsAddModalOpen(false)}
        width="w-[95%] sm:w-[90%] md:w-[80%] lg:w-[60%] xl:w-[50%] max-w-4xl"
      >
        <div className="w-full px-4 sm:px-6 md:px-8 py-6 mx-auto text-white">
          <h3 className="text-xl text-center font-semibold mb-6">
            {translations.dummyBooking.addDummyBooking}
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* User */}
            <div>
              <label className="block text-gray-300 text-sm mb-1">
                {translations.dummyBooking.user}
              </label>
              <select
                value={dummyBooking.user_id}
                onChange={(e) =>
                  setDummyBooking({ ...dummyBooking, user_id: e.target.value })
                }
                className={`w-full rounded-md border ${
                  errors.userId ? "border-red-500" : "border-dark-3"
                } bg-gray-700 text-white px-4 py-2.5`}
              >
                <option value="" className="text-gray-400" disabled>
                  Select user
                </option>
                {users.map((u) => (
                  <option key={u._id} value={u._id}>
                    {u.name}
                  </option>
                ))}
              </select>
              {errors.user_id && (
                <p className="text-red-500 text-sm mt-1">{errors.user_id}</p>
              )}
            </div>

            {/* Salon */}
            <div>
              <label className="block text-gray-300 text-sm mb-1">
                {translations.dummyBooking.salon}
              </label>
              <select
                value={dummyBooking.salon_id}
                onChange={(e) => {
                  const newSalonId = e.target.value;
                  setDummyBooking({
                    ...dummyBooking,
                    salon_id: newSalonId,
                    staff_id: "", // Reset staff when salon changes
                    service_ids: [], // Reset services array when salon changes
                  });
                  setSalonIdState(newSalonId);
                  setSelectedStaff(null); // Clear selected staff
                }}
                className={`w-full rounded-md border ${
                  errors.salon_id ? "border-red-500" : "border-dark-3"
                } bg-gray-700 text-white px-4 py-2.5`}
              >
                <option value="" className="text-gray-400" disabled>
                  Select salon
                </option>
                {salons.map((s) => (
                  <option key={s._id} value={s._id}>
                    {s.business_name}
                  </option>
                ))}
              </select>
              {errors.salon_id && (
                <p className="text-red-500 text-sm mt-1">{errors.salon_id}</p>
              )}
            </div>

            {/* Staff */}
            <div>
              <label className="block text-gray-300 text-sm mb-1">
                {translations.dummyBooking.staff}
              </label>
              <select
                value={dummyBooking.staff_id}
                onChange={(e) => {
                  const staffId = e.target.value;
                  const staff = staffList.find((s) => s._id === staffId);

                  setDummyBooking({
                    ...dummyBooking,
                    staff_id: staffId,
                    service_ids: [], // Reset services array when staff changes
                  });
                  setSelectedStaff(staff || null);
                }}
                disabled={!dummyBooking.salon_id}
                className={`w-full rounded-md border ${
                  errors.staff_id ? "border-red-500" : "border-dark-3"
                } bg-gray-700 text-white px-4 py-2.5 ${
                  !dummyBooking.salon_id ? "opacity-50 cursor-not-allowed" : ""
                }`}
              >
                <option value="" className="text-gray-400" disabled>
                  Select staff
                </option>
                {dummyBooking.salon_id && staffList.length === 0 ? (
                  <option disabled>No staff available</option>
                ) : (
                  staffList.map((s) => (
                    <option key={s._id} value={s._id}>
                      {s.name}
                    </option>
                  ))
                )}
              </select>
              {errors.staff_id && (
                <p className="text-red-500 text-sm mt-1">{errors.staff_id}</p>
              )}
            </div>

            {/* Booking Date */}
            <div>
              <label className="block text-gray-300 text-sm mb-1">
                {translations.dummyBooking.bookingDate}
              </label>
              <input
                type="date"
                value={dummyBooking.booking_date}
                min={new Date().toISOString().split("T")[0]}
                onChange={(e) => {
                  const rawValue = e.target.value;
                  const formatted = new Date(rawValue)
                    .toISOString()
                    .split("T")[0];
                  setDummyBooking({ ...dummyBooking, booking_date: formatted });
                }}
                className={`w-full rounded-md border ${
                  errors.booking_date ? "border-red-500" : "border-dark-3"
                } bg-gray-700 text-white px-4 py-2.5`}
              />
              {errors.booking_date && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.booking_date}
                </p>
              )}
            </div>

            {/* Start Time */}
            <div>
              <label className="block text-gray-300 text-sm mb-1">
                {translations.dummyBooking.startTime}
              </label>
              <select
                value={dummyBooking.start_time}
                onChange={(e) =>
                  setDummyBooking({
                    ...dummyBooking,
                    start_time: e.target.value,
                  })
                }
                className={`w-full rounded-md border ${
                  errors.start_time ? "border-red-500" : "border-dark-3"
                } bg-gray-700 text-white px-4 py-2.5`}
              >
                <option value="" className="text-gray-400" disabled>
                  Select time
                </option>
                {generateTimeSlots("10:00", "22:00").map((time) => (
                  <option key={time} value={time}>
                    {time}
                  </option>
                ))}
              </select>
              {errors.start_time && (
                <p className="text-red-500 text-sm mt-1">{errors.start_time}</p>
              )}
            </div>

            {/* Total Duration */}
            <div>
              <label className="block text-gray-300 text-sm mb-1">
                {translations.dummyBooking.totalDuration}
              </label>
              <input
                type="number"
                value={dummyBooking.total_duration}
                placeholder={translations.dummyBooking.durationPlaceholder}
                onChange={(e) =>
                  setDummyBooking({
                    ...dummyBooking,
                    total_duration: Number(e.target.value),
                  })
                }
                className={`w-full rounded-md border ${
                  errors.total_duration ? "border-red-500" : "border-dark-3"
                } bg-gray-700 text-white px-4 py-2.5`}
              />
              {errors.total_duration && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.total_duration}
                </p>
              )}
            </div>

            {/* Payment Method */}
            <div>
              <label className="block text-gray-300 text-sm mb-1">
                {translations.dummyBooking.paymentMethod}
              </label>
              <select
                value={dummyBooking.payment_method}
                onChange={(e) =>
                  setDummyBooking({
                    ...dummyBooking,
                    payment_method: Number(e.target.value),
                  })
                }
                className={`w-full rounded-md border ${
                  errors.payment_method ? "border-red-500" : "border-dark-3"
                } bg-gray-700 text-white px-4 py-2.5`}
              >
                <option value="" className="text-gray-400" disabled>
                  Select method
                </option>
                <option value="21">Cash</option>
                <option value="22">Card</option>
                <option value="23">Wallet</option>
              </select>
              {errors.payment_method && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.payment_method}
                </p>
              )}
            </div>

            {/* Promo Code */}
            <div>
              <label className="block text-gray-300 text-sm mb-1">
                {translations.dummyBooking.promoCode}
              </label>
              <select
                value={dummyBooking.promoCode}
                onChange={(e) =>
                  setDummyBooking({
                    ...dummyBooking,
                    promoCode: e.target.value,
                  })
                }
                className="w-full rounded-md border border-dark-3 bg-gray-700 text-white px-4 py-2.5"
              >
                <option value="" className="text-gray-400" disabled>
                  Select coupon
                </option>
                {promoCodes.map((p) => (
                  <option key={p._id} value={p.code}>
                    {p.code}
                  </option>
                ))}
              </select>
            </div>

            {/* Services */}
            <div>
              <label className="block text-gray-300 text-sm mb-1">
                {translations.dummyBooking.services}
              </label>
              <div
                className={`w-full rounded-md border ${
                  errors.service_ids ? "border-red-500" : "border-dark-3"
                } bg-gray-700 text-white px-4 py-2.5 ${
                  !dummyBooking.staff_id ? "opacity-50 cursor-not-allowed" : ""
                }`}
              >
                {selectedStaff?.services?.length > 0 ? (
                  <div className="space-y-2 max-h-32 overflow-y-auto">
                    {selectedStaff.services.map((serviceObj) => (
                      <label
                        key={serviceObj._id}
                        className="flex items-center space-x-2 cursor-pointer"
                      >
                        <input
                          type="checkbox"
                          disabled={!dummyBooking.staff_id}
                          checked={dummyBooking.service_ids.includes(
                            serviceObj._id
                          )}
                          onChange={(e) => {
                            if (e.target.checked) {
                              // Add service ID to array
                              setDummyBooking({
                                ...dummyBooking,
                                service_ids: [
                                  ...dummyBooking.service_ids,
                                  serviceObj._id,
                                ],
                              });
                            } else {
                              // Remove service ID from array
                              setDummyBooking({
                                ...dummyBooking,
                                service_ids: dummyBooking.service_ids.filter(
                                  (serviceId) => serviceId !== serviceObj._id
                                ),
                              });
                            }
                          }}
                          className="w-4 h-4 text-blue-600 bg-gray-600 border-gray-500 rounded focus:ring-blue-500"
                        />
                        <span className="text-sm">
                          {serviceObj.service_name}
                        </span>
                      </label>
                    ))}
                  </div>
                ) : (
                  dummyBooking.staff_id && (
                    <p className="text-gray-400 text-sm">
                      No services available
                    </p>
                  )
                )}
                {!dummyBooking.staff_id && (
                  <p className="text-gray-400 text-sm">Select staff first</p>
                )}
              </div>
              {errors.service_id && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.service_ids}
                </p>
              )}
            </div>
          </div>

          {/* Footer buttons */}
          <div className="flex flex-col sm:flex-row justify-end gap-3 mt-6">
            <button
              onClick={() => {
                setIsAddModalOpen(false);
                setDummyBooking(initialDummyBooking);
                setErrors({}); // Clear errors when closing
                setSelectedStaff(null); // Clear selected staff
              }}
              className="w-full sm:w-auto px-4 py-2 rounded bg-gray-600 hover:bg-gray-500"
            >
              {translations.dummyBooking.cancel}
            </button>
            <button
              onClick={validateAndSubmit}
              className="w-full sm:w-auto px-4 py-2 rounded bg-blue-600 hover:bg-blue-700"
            >
              {translations.dummyBooking.submit}
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default Booking;
